import * as React from 'react'
import {ReactElement} from 'react'
import {Box} from '@mui/material'
import {Colors, FontSize} from '../../../../styledComponents/Constants'
import {FullWidthColumnFlexContainer, LeftRowFlexContainer} from '../../../../styledComponents/FlexComponents'
import {BlockSpacer} from '../../../../styledComponents/ResponsiveConvenience'
import {PlainBackLink} from '../../../../styledComponents/Links'
import {DisplayItemDividerForPageTop} from '../../../../styledComponents/DisplayItem'
import {
    ApplyButton,
    BoldText,
    ListGridContainer,
    PageTitle,
    PledgeArea,
    PolicyCheckBoxStyled,
} from '../common/resident/NatResidentApplicationsCommon'
import {
    createResidentWithErrorHandlingPage,
    ResidentWithErrorHandlingPagePropsSet,
} from '../../../../components/shared/hoc/createResidentWithErrorHandlingPage'
import {Nullable} from '../../../../app/TypeHelpers'
import {Location} from 'react-router-dom'

interface Props {
    condominiumCd: string
    applyId?: string
    location: Location
}

interface State {
    policyChecked: boolean
    applyButtonDisabled: boolean
}

class NatResidentBrowseAgreementPage
    extends React.Component<Props & ResidentWithErrorHandlingPagePropsSet, State> {

    constructor(props: Props & ResidentWithErrorHandlingPagePropsSet) {
        super(props)

        this.state = {
            policyChecked: false,
            applyButtonDisabled: true,
        }

        this.onChangePolicyChecked = this.onChangePolicyChecked.bind(this)
        this.onClickApplyButton = this.onClickApplyButton.bind(this)
    }

    onChangePolicyChecked(event: React.ChangeEvent<HTMLInputElement>): void {
        this.setState({
            policyChecked: event.target.checked,
        }, () => {
            this.updateApplyButtonDisabled()
        })
    }

    updateApplyButtonDisabled(): void {
        const {policyChecked} = this.state

        if (policyChecked) {
            this.setState({applyButtonDisabled: false})
        } else {
            this.setState({applyButtonDisabled: true})
        }
    }

    onClickApplyButton(): void {
        this.props.navigate(
            `/resident/condominiums/${this.props.condominiumCd}/applications/browses/input`,
            {
                state: {
                    applyId: this.props.applyId,
                },
            },
        )
    }

    renderPolicy(): Nullable<ReactElement> {
        return (<>
            <Box height={'15px'}/>
            <PledgeArea fontSize={FontSize.Middle}>
                <Box p={'10px'}>
                    <BoldText fontColor={Colors.AccentDark}>誓約文</BoldText>
                    <Box height={'5px'}/>
                    私は、防犯カメラ運用規則を遵守することを誓約し、次の通り閲覧許可の申請をいたします。
                </Box>
            </PledgeArea>
            <Box height={'20px'}/>
            <FullWidthColumnFlexContainer>
                <PolicyCheckBoxStyled>
                    <LeftRowFlexContainer>
                        <input
                            type="checkbox"
                            checked={this.state.policyChecked}
                            onChange={this.onChangePolicyChecked}
                        />
                        <BlockSpacer width={'10px'}/>
                        誓約文に同意する
                    </LeftRowFlexContainer>
                </PolicyCheckBoxStyled>
            </FullWidthColumnFlexContainer>
        </>)
    }

    render(): ReactElement {
        return (
            <>
                <PlainBackLink
                    to={this.props.applyId
                        ? `/resident/condominiums/${this.props.condominiumCd}/applications/browses/${this.props.applyId}`
                        : `/resident/condominiums/${this.props.condominiumCd}/applications`}>
                    戻る
                </PlainBackLink>
                <BlockSpacer height={'16px'}/>
                <DisplayItemDividerForPageTop/>
                <BlockSpacer height={'30px'}/>
                <PageTitle>
                    閲覧申請書
                </PageTitle>
                <Box height={'20px'}/>
                <Box>
                    マンション内の防犯カメラの録画映像の閲覧を希望する場合に提出が必要です。
                    <Box height={'10px'}/>
                    <ListGridContainer fontSize={FontSize.Middle}>
                        <div>・</div>
                        <div>
                            防犯カメラ運用規則を事前にご確認いただいたうえで本申請手続きを実施してください。
                        </div>
                        <div>・</div>
                        <div>
                            理事会にて審査を実施するため、申請結果の通知までにお時間をいただくことがございます。
                        </div>
                        <div>・</div>
                        <div>
                            申請承認時、閲覧日の日程と立会いする理事等について、承認メールにて連絡いたします。
                        </div>
                    </ListGridContainer>
                </Box>
                {this.renderPolicy()}
                <ApplyButton
                    disabled={this.state.applyButtonDisabled}
                    onClick={this.onClickApplyButton}>
                    <FullWidthColumnFlexContainer>
                        <div>
                            申請を開始する
                        </div>
                    </FullWidthColumnFlexContainer>
                </ApplyButton>
            </>
        )
    }
}

export default createResidentWithErrorHandlingPage(NatResidentBrowseAgreementPage)
